/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EarlyAccessRegistration } from '../housien-models/EarlyAccessRegistration';
import type { SuccessResponse } from '../housien-models/SuccessResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

/**
 * EarlyAccessService class.
 */
export class EarlyAccessService {

    /**
     * Get Early Access Information
     * Returns the early access information if it exists, or an empty payload otherwise.
     * @returns EarlyAccessRegistration Early access information retrieved successfully.
     * @throws ApiError
     */
    public static getEarlyAccess(): CancelablePromise<EarlyAccessRegistration> {
        return __request(OpenAPIHousien, {
            method: 'GET',
            url: '/early-access',
        });
    }

    /**
     * Register Early Access Information
     * Registers the early access information.
     * @param requestBody 
     * @returns SuccessResponse Early access information registered successfully.
     * @throws ApiError
     */
    public static postEarlyAccess(
requestBody: EarlyAccessRegistration,
): CancelablePromise<SuccessResponse> {
        return __request(OpenAPIHousien, {
            method: 'POST',
            url: '/early-access',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete Early Access Registration (debug mode only)
     * Deletes the current user's early access registration. Only available
     * when the backend is running in debug mode.
     * @returns SuccessResponse Early access registration deleted successfully.
     * @throws ApiError
     */
    public static deleteEarlyAccess(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPIHousien, {
            method: 'DELETE',
            url: '/early-access',
        });
    }

}
